import React from 'react'
import { useForm } from '@inertiajs/inertia-react'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

function formatDate(val) {
    if (!val) return ''
    const d = String(val).slice(0, 10)
    const [y, m, day] = d.split('-')
    return `${day}/${m}/${y}`
}

const ClaimTestimonialGallery = ({ testimonials, offices, filters }) => {
    const filterForm = useForm({ search: filters.search || '', office_id: filters.office_id || '' })
    const items = testimonials.data || []

    return (
        <Row>
            <Col xs={12}><Breadcrumbs currentPath="admin/claims/videos" /></Col>
            <Col xs={12}>
                <div className="card card-flush">
                    <div className="card-header pt-7">
                        <h3 className="card-title fw-bold text-gray-800">SINIESTROS — Videos testimoniales</h3>
                    </div>
                    <div className="card-body pt-6">
                        <Form
                            onSubmit={(e) => { e.preventDefault(); filterForm.get(route('claims.testimonials.gallery'), { preserveState: true }) }}
                            className="row g-3 mb-8"
                        >
                            <Col md={3}>
                                <Form.Label className="fs-7 fw-bold text-gray-600">Buscar por oficina</Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={filterForm.data.office_id}
                                    onChange={(e) => filterForm.setData('office_id', e.target.value)}
                                >
                                    <option value="">Todas</option>
                                    {offices.map((o) => <option key={o.id} value={o.id}>{o.nombre}</option>)}
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                                <Form.Label className="fs-7 fw-bold text-gray-600">Buscar por nombre</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={filterForm.data.search}
                                    onChange={(e) => filterForm.setData('search', e.target.value)}
                                    placeholder="Nombre del asegurado"
                                />
                            </Col>
                            <Col md="auto" className="d-flex align-items-end">
                                <Button type="submit" size="sm" variant="primary">Buscar</Button>
                            </Col>
                        </Form>

                        {items.length === 0 ? (
                            <p className="text-muted text-center py-10">No hay videos testimoniales registrados.</p>
                        ) : (
                            <Row className="g-4">
                                {items.map((item) => (
                                    <Col key={item.id} xs={12} md={6} lg={4}>
                                        <div className="card h-100 shadow-sm border">
                                            <div className="ratio ratio-16x9 rounded-top overflow-hidden">
                                                <iframe
                                                    title={item.insured_name}
                                                    src={`https://www.youtube.com/embed/${item.youtube_video_id}`}
                                                    allowFullScreen
                                                />
                                            </div>
                                            <div className="card-body d-flex flex-column">
                                                <span className="text-muted text-uppercase fs-8 fw-semibold mb-1">
                                                    Oficina: {item.office?.nombre}
                                                </span>
                                                <h6 className="fw-bold text-gray-900 mb-1">{item.insured_name}</h6>
                                                <span className="text-gray-600 fs-7 mb-3">{formatDate(item.video_date)}</span>
                                                {item.story && (
                                                    <p
                                                        className="text-gray-700 fs-7 mb-0 flex-grow-1"
                                                        style={{ lineHeight: 1.5, maxHeight: 140, overflow: 'hidden' }}
                                                    >
                                                        {item.story}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        )}

                        <PaginationList
                            links={testimonials.links}
                            filters={{ search: filters.search || undefined, office_id: filters.office_id || undefined }}
                        />
                    </div>
                </div>
            </Col>
        </Row>
    )
}

ClaimTestimonialGallery.layout = (page) => <Layout title="Galería de videos">{page}</Layout>

export default ClaimTestimonialGallery
